import { ApiSchemas } from '@/components/providers/v1-api';
import { Badge } from '@/components/ui/badge';

type CallData = ApiSchemas['ExternalCallDetailOut'];

export function CallInsights({ call }: { call: CallData }) {
  return (
    <div className='flex flex-col gap-8'>
      <div className='grid grid-cols-2 gap-4'>
        <TalkBalanceCards call={call} />
        <SpeakingPaceCards call={call} />
      </div>
    </div>
  );
}

export function TalkBalanceCards({ call }: { call: CallData }) {
  const csrDurationMs = call?.agent_duration_ms ?? 0;
  const userDurationMs = call?.user_duration_ms ?? 0;
  const total = csrDurationMs + userDurationMs;
  const csrPercent = total > 0 ? Math.round((csrDurationMs / total) * 100) : 0;
  const userPercent = total > 0 ? Math.round((userDurationMs / total) * 100) : 0;

  return (
    <div className='w-full rounded-lg bg-background p-4 shadow-md'>
      <h3 className='text-heading-sm'>Talk Balance</h3>
      <div className='mt-5 flex h-2 items-center rounded-full bg-muted/50 shadow-md'>
        <div className='h-full rounded-full rounded-r-none bg-muted' style={{ width: `${csrPercent}%` }} />
        <div className='h-full rounded-full rounded-l-none bg-primary/80' style={{ width: `${userPercent}%` }} />
      </div>
      <div className='mt-2 flex flex-row justify-between gap-2 px-1'>
        <div className='text-sm text-muted-foreground'>
          <div className='text-xs font-medium'>CSR: {csrPercent}%</div>
        </div>
        <div className='text-sm text-muted-foreground'>
          <div className='text-xs font-medium'>Customer: {userPercent}%</div>
        </div>
      </div>
    </div>
  );
}

export function SpeakingPaceCards({ call }: { call: CallData }) {
  function getDescription({ wpm }: { wpm: number }) {
    if (wpm < 100) return 'Poor speaking pace';
    if (wpm < 140) return 'OK speaking pace';
    return 'Good speaking pace';
  }

  return (
    <div className='w-full rounded-lg bg-background p-4 shadow-md'>
      <h3 className='text-heading-sm'>Speaking Pace</h3>
      <div className='mt-2.5 flex items-center justify-between gap-2'>
        <div>
          <Badge variant='outline'>CSR: {call?.agent_wpm ?? 0} WPM</Badge>
          <div className='mt-1 px-1 text-xs text-muted-foreground'>{getDescription({ wpm: call?.agent_wpm ?? 0 })}</div>
        </div>
        <div>
          <Badge variant='outline'>Customer: {call?.user_wpm ?? 0} WPM</Badge>
          <div className='mt-1 px-1 text-right text-xs text-muted-foreground'>
            {getDescription({ wpm: call?.user_wpm ?? 0 })}
          </div>
        </div>
      </div>
    </div>
  );
}
